import { render, staticRenderFns } from "./ExtraInfosCoureur.vue?vue&type=template&id=40331e4a&scoped=true&"
import script from "./ExtraInfosCoureur.vue?vue&type=script&lang=js&"
export * from "./ExtraInfosCoureur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40331e4a",
  null
  
)

export default component.exports